import { makeStyles } from "@/utils/makeStyles"
import { FONT } from "@/styles/fonts"
import { themeColors } from "@/styles"

const useStyles = makeStyles(() => ({
	button: {
		borderRadius: "0.25rem",
		minHeight: "3.25rem",
		minWidth: "3.25rem",
		textTransform: "none",
		fontSize: FONT.size.default,
		fontFamily: "IBM Plex Sans, sans-serif",
		lineHeight: "normal",
		fontWeight: FONT.fontWeight["medium"],
		padding: "1rem",
		"&.Mui-disabled": {
			color: themeColors.colors.system.gray[400],
			backgroundColor: themeColors.colors.system.gray[100],
			border: "none"
		}
	},
	primary: {
		color: themeColors.colors.base.white,
		backgroundColor: themeColors.getPrimaryColor(),
		"&:hover": {
			backgroundColor: themeColors.colors.primary[800]
		},
		"&:active": {
			backgroundColor: themeColors.colors.primary[900]
		}
	},
	secondary: {
		color: themeColors.getPrimaryColor(),
		borderColor: themeColors.colors.system.gray[100],
		backgroundColor: themeColors.colors.base.white,
		"&:hover": {
			backgroundColor: themeColors.colors.primary[50]
		},
		"&:active": {
			backgroundColor: themeColors.colors.primary[800],
			color: themeColors.colors.base.white
		}
	},
	tertiary: {
		color: themeColors.colors.base.white,
		backgroundColor: themeColors.colors.quaternary[500],
		"&:hover": {
			backgroundColor: themeColors.colors.quaternary[700]
		},
		"&:active": {
			backgroundColor: themeColors.colors.quaternary[900]
		}
	},
	ghost: {
		color: themeColors.getPrimaryColor(),
		"&:hover": {
			backgroundColor: themeColors.colors.primary[50]
		},
		"&:active": {
			backgroundColor: themeColors.colors.primary[500],
			color: themeColors.colors.base.white
		}
	},
	outlined: {
		backgroundColor: "transparent",
		color: themeColors.colors.system.purple[500],
		border: `1px solid ${themeColors.colors.system.purple[500]}`,
		borderRadius: "8px",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[50]
		}
	}
}))

export default useStyles